<template>
    <v-app class="pagina">
        <div class="viewPagina">
            <Editora></Editora>
        </div>
    </v-app>
</template>
<script>
import Editora from './components/Editora.vue';
export default {
    data: () => ({}),
    components: {
        Editora
    }
};
</script>
